// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-YdI","colBig":"styles_colBig__31p2j","colSmall":"styles_colSmall__3Vhx2"};